import React, { useEffect, useState } from "react";
import FontIcon from "react-md/lib/FontIcons";
import "../styles/expandableTableAssignedChildServices.css";
import EventService from "../../../../../service/event/EventService";
import moment from "moment";
import NoRecordsIcon from "../../../../../assets/icons/no-records.png";
import { Button, SelectField } from "react-md";
import filterApplied from "../../../../../assets/icons/filter-applied-icon.svg";
import funnelIcon from "../../../../../assets/icons/funnel.svg";
import goIcon from "../../../../../assets/icons/right_arrow_go_btn.svg";
import {
  TextField,
  MenuItem,
  Menu,
  IconButton,
  Radio,
} from "@material-ui/core";
import DeleteIcon from "react-md-icon/dist/OutlineDelete";

const ExpandableTableAssignedChildServices = (props) => {
  const [expandedRowId, setExpandedRowId] = useState(null); // state to track expanded row
  const [anchorEl, setAnchorEl] = useState(null);
  const [menuFor, setMenuFor] = useState({});
  const [tableData, setTableData] = useState(props?.assignedChildServices);
  const [providerMap, setProviderMap] = useState(props?.providerMap);
  const [filterObj, setFilterObj] = useState({});
  const [serviceId, setServiceId] = useState("");
  const [openFilter, setOpenFilter] = useState(false);
  const [openBackdrop, setOpenBackdrop] = useState(false);

  const [loading, setLoading] = useState(false);

  useEffect(() => {
    console.log("props recvd in expandabel table: ", props);
  }, []);

  useEffect(() => {
    setTableData(props?.assignedChildServices);
    setProviderMap(props?.providerMap);
    console.log("props recvd in expandabel table: ", props);
  }, [props]);

  useEffect(() => {
    if (!(props?.fetchAssignedChildServicesOnInit == false)) {
      props.fetchAssignedChildServicesByFilter(filterObj);
    }
    console.log("props recvd in expandabel table: ", props);
  }, [filterObj]);

  const STATUS_MAP = {
    Active: "active",
    Inactive: "inactive",
  };

  const checkIsThisServiceStagedForUpdate = (service) => {
    return (props?.stagedForUpdateChildServices ?? []).some(
      (stagedService) => (stagedService?.id ?? -2) === (service?.id ?? -1)
    );
  };

  const handleRowClick = (id) => {
    setExpandedRowId(expandedRowId === id ? null : id); // toggle expansion
  };
  const handleMoreClick = (event, service) => {
    setAnchorEl(event.currentTarget);
    setMenuFor({ planData: props?.planData, service: service });
  };

  const stringToInt = (str) => {
    const num = parseInt(str, 10); // Convert string to integer with base 10
    return isNaN(num) ? null : num; // Check if conversion failed
  };

  const getRestOfTheProvidersModesForThisServiceWithLimit = (
    allProviders,
    limit = Number.MAX_SAFE_INTEGER,
    ignoreFirstOne = false
  ) => {
    let ignoreFirstOneFlag = ignoreFirstOne; // Flag to determine whether to ignore the first provider

    let result = {};
    let totalElementsAdded = 0;
    console.log("all providers: ", allProviders);
    for (let index = 0; index < allProviders?.length; index++) {
      const element = allProviders[index];
      console.log("allProviders[index] : ", element);
      if (totalElementsAdded >= limit) {
        break;
      }
      if (
        element?.serviceProviderId &&
        element?.serviceModes?.length > 0 &&
        totalElementsAdded <= limit
      ) {
        if (ignoreFirstOneFlag) {
          result = {
            ...result,
            [element.serviceProviderId]: {
              modes: (element?.serviceModes ?? []).slice(
                1,
                limit - totalElementsAdded
              ), // Add only the remaining number of modes to reach the limit
              providerElement: element,
            },
          };
          ignoreFirstOneFlag = false; // Reset the flag after ignoring the first provider mode
        } else {
          result = {
            ...result,
            [element.serviceProviderId]: {
              modes: (element?.serviceModes ?? []).slice(
                0,
                limit - totalElementsAdded
              ), // Add only the remaining number of modes to reach the limit
              providerElement: element,
            },
          };
        }
        totalElementsAdded +=
          result?.[element.serviceProviderId]?.modes?.length ?? 0; // Increment by the actual number of modes added for this provider
      }
    }

    console.log(
      "result after processing providers and modes with limit: ",
      result
    );

    return result;
  };

  const getTotalProviderModesCount = (allProviders) =>
    (allProviders ?? []).reduce(
      (sum, provider) =>
        sum +
        (provider?.serviceProviderId ? provider?.serviceModes?.length ?? 0 : 0),
      0
    );

  const getRenderedProviderModesCount = (allProviders) =>
    // the first provider mode is rendered in the main row, the rest come from
    // the limited list below it
    1 +
    Object.values(
      getRestOfTheProvidersModesForThisServiceWithLimit(
        allProviders,
        props?.provdersLimit,
        true
      ) ?? {}
    ).reduce((sum, item) => sum + (item?.modes?.length ?? 0), 0);

  // "See all" has to appear whenever a provider mode is left out of the row.
  // The earlier check compared the truncated list against itself, so modes of a
  // single provider beyond the second one were dropped without any way to see
  // them - a mode added to a provider later on simply never showed up here.
  const areProviderModesTruncated = (allProviders) =>
    getTotalProviderModesCount(allProviders) >
    getRenderedProviderModesCount(allProviders);

  return (
    <div className="table-container-assigned-plans">
      <table className="expandable-table">
        <thead>
          <tr>
            <th>
              Service ID
              <img
                src={
                  (filterObj?.serviceIds?.length ?? 0) > 0
                    ? filterApplied
                    : funnelIcon
                }
                onClick={() => {
                  setOpenBackdrop(true);
                  setOpenFilter(2);
                }}
              />
              {openFilter === 2 && (
                <div className="filter-div-assigned-plans-table">
                  <div className="can-be-booked-for-filter">
                    <TextField
                      placeholder="Service ID"
                      type="text"
                      value={serviceId}
                      onChange={(e) => {
                        setServiceId(e.target.value);
                        if (e.target.value == "") {
                          setFilterObj((prev) => ({
                            ...prev,
                            serviceIds: [],
                          }));
                        }
                      }}
                    />
                    <img
                      src={goIcon}
                      alt="Go"
                      style={{
                        width: "20px",
                        height: "20px",
                        cursor: "pointer",
                        marginBottom: "-10px",
                      }}
                      onClick={() => {
                        const parsedServiceId = stringToInt(serviceId);
                        setOpenBackdrop(false);
                        setOpenFilter(-1);
                        setFilterObj((prev) => ({
                          ...prev,
                          serviceIds:
                            parsedServiceId === null ? [] : [parsedServiceId],
                        }));
                      }}
                    />
                  </div>
                </div>
              )}
            </th>
            <th>Service name</th>
            <th>Service code</th>
            <th>Service mode</th>
            <th>Service provider</th>
            <th>Cost price</th>
            <th>MRP</th>
            <th>Discounted price</th>
            <th>
              Status
              <img
                className="filter-icon-assigned-plans"
                src={filterObj?.serviceModeStatus ? filterApplied : funnelIcon}
                onClick={() => {
                  setOpenBackdrop(true);
                  setOpenFilter(1);
                }}
              />
              {openFilter === 1 && (
                <div className="filter-div-assigned-plans-table">
                  <div className="can-be-booked-for-filter">
                    {Object.entries(STATUS_MAP).map(([key, val]) => (
                      <div>
                        <Radio
                          label={key}
                          checked={filterObj?.serviceModeStatus == val}
                          onClick={() => {
                            setOpenBackdrop(false);
                            setOpenFilter(-1);
                            setFilterObj((prev) => ({
                              ...prev,
                              serviceModeStatus: val,
                            }));
                          }}
                        />
                        <label className="label-radio-btn">{key}</label>
                      </div>
                    ))}
                    <Button
                      className="clear-navigo-booked-for"
                      onClick={() => {
                        setFilterObj((prev) => ({
                          ...prev,
                          serviceModeStatus: null,
                        }));
                      }}
                    >
                      Clear
                    </Button>
                  </div>
                </div>
              )}
            </th>
            <th></th>
            <th></th>
          </tr>
        </thead>
        <tbody className="animated-box">
          {Boolean(tableData?.length == null || tableData?.length <= 0) && (
            <tr>
              <td colSpan={10}>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    padding: 40,
                  }}
                >
                  <div
                    style={{ textAlign: "center", fontFamily: "Montserrat" }}
                  >
                    No records to show
                  </div>
                  <div style={{ height: "16px" }}></div>
                  <img src={NoRecordsIcon} width={50} height={62} />
                </div>
              </td>
            </tr>
          )}

          {tableData &&
            tableData.length > 0 &&
            Boolean(props?.showPagination ?? true) && (
              <tr>
                <td />
                <td />
                <td />
                <td />
                <td />
                <td />
                <td />
                <td />
                <td
                  colSpan={10}
                  align="right"
                  style={{ display: "flex", flexDirection: "row" }}
                >
                  <Button
                    onClick={() => {
                      props.goToPrevPage();
                    }}
                    disabled={props?.pageNum <= 1 || loading}
                  >
                    <FontIcon className="navigo-count-icon">
                      arrow_left
                    </FontIcon>
                  </Button>
                  <div style={{ display: "flex", flexDirection: "row" }}>
                    Showing&nbsp;
                    <span
                      style={{
                        color: "#ef7c01",
                        display: "flex",
                        flexDirection: "row",
                      }}
                    >
                      {(props?.pageNum - 1) * props?.pageSize + 1}&nbsp;
                    </span>
                    <span
                      style={{
                        color: "#ef7c01",
                      }}
                    >
                      -
                    </span>
                    <span
                      style={{
                        color: "#ef7c01",
                        display: "flex",
                        flexDirection: "row",
                      }}
                    >
                      &nbsp;
                      {props?.totalCount > props?.pageNum * props?.pageSize
                        ? props?.pageNum * props?.pageSize
                        : props?.totalCount}
                    </span>
                    <span>&nbsp;&nbsp;of&nbsp;</span>
                    <span>{` ${props?.totalCount}`}</span>
                  </div>
                  <Button
                    onClick={() => {
                      props.goToNextPage();
                    }}
                    disabled={
                      loading ||
                      props?.pageNum * props?.pageSize > props?.totalCount ||
                      (props?.totalCount > props?.pageNum * props?.pageSize
                        ? props?.pageNum * props?.pageSize
                        : props?.totalCount) == props?.totalCount
                    }
                  >
                    <FontIcon>arrow_right</FontIcon>
                  </Button>
                </td>
                <td />
                <td />
              </tr>
            )}

          {(tableData ?? []).map((row, index) => (
            <React.Fragment key={index}>
              <tr
                // onClick={() => handleRowClick(row?.id)}
                style={
                  checkIsThisServiceStagedForUpdate(row)
                    ? { backgroundColor: "#FBDFD9" }
                    : {}
                }
                className={`${index > 0 ? "table-row-border" : ""}`}
              >
                <td>{row?.id}</td>
                <td>{row?.serviceName}</td>
                <td>{row?.name}</td>
                <td>
                  {row?.id
                    ? providerMap?.[row.id]?.[0]?.serviceModes?.[0]?.mode ?? "-"
                    : "-"}
                </td>
                <td>
                  {row?.id
                    ? `(${
                        providerMap?.[row.id]?.[0]?.serviceProviderId ?? "-"
                      })${
                        providerMap?.[row.id]?.[0]?.serviceProviderName ?? "-"
                      }`
                    : "-"}
                </td>

                <td>{providerMap?.[row.id]?.[0]?.serviceModes?.[0]?.price}</td>
                <td>
                  {
                    providerMap?.[row.id]?.[0]?.serviceModes?.[0]
                      ?.maxRetailPrice
                  }
                </td>
                <td>
                  {providerMap?.[row.id]?.[0]?.serviceModes?.[0]
                    ?.discountedPrice === null ||
                  providerMap?.[row.id]?.[0]?.serviceModes?.[0]
                    ?.discountedPrice === undefined
                    ? "-"
                    : providerMap?.[row.id]?.[0]?.serviceModes?.[0]
                        .discountedPrice}
                </td>

                <td>
                  <div
                    className={`${
                      providerMap?.[row.id]?.[0]?.serviceModes?.[0]?.modeStatus
                        ? "navigo-appoint-non-select-status-active"
                        : "navigo-appoint-non-select-status-inactive"
                    }`}
                  >
                    <span>
                      {providerMap?.[row.id]?.[0]?.serviceModes?.[0]
                        ?.modeStatus == true
                        ? "Active"
                        : "Inactive"}
                    </span>
                  </div>
                </td>
                <td>
                  {Boolean(props?.mode !== "view") && (
                    <IconButton
                      onClick={(e) => {
                        if (
                          !checkIsThisServiceStagedForUpdate(row) &&
                          props?.handleDeleteAssignedChildService
                        ) {
                          props.handleDeleteAssignedChildService(row);
                        }
                      }}
                      style={{
                        cursor: "pointer",
                        visibility: checkIsThisServiceStagedForUpdate(row)
                          ? "hidden"
                          : "visible",
                      }}
                    >
                      <DeleteIcon
                        style={{
                          // fontSize: "10em",
                          color: "orange",
                        }}
                      />
                    </IconButton>
                  )}
                </td>
                <td></td>
              </tr>
              {Object.entries(
                getRestOfTheProvidersModesForThisServiceWithLimit(
                  providerMap?.[row.id] ?? [],
                  props?.provdersLimit,
                  true
                ) ?? {}
              ).map(([serviceProviderId, modesObj]) =>
                (modesObj?.modes ?? []).map((roww, index) => (
                  <tr
                    key={index}
                    className="table-row-expanded animated-box"
                    style={
                      checkIsThisServiceStagedForUpdate(row)
                        ? { backgroundColor: "#FBDFD9" }
                        : {}
                    }
                  >
                    <td></td>
                    <td></td>
                    <td></td>
                    <td>{roww?.mode ?? "-"}</td>
                    <td>
                      {`(${serviceProviderId})${
                        modesObj?.providerElement?.serviceProviderName ?? "-"
                      }`}
                    </td>
                    <td>{roww?.price}</td>
                    <td>{roww?.maxRetailPrice}</td>
                    <td>
                      {roww?.discountedPrice === null ||
                      roww?.discountedPrice === undefined
                        ? "-"
                        : roww.discountedPrice}
                    </td>
                    <td>
                      <div
                        className={`${
                          roww?.modeStatus
                            ? "navigo-appoint-non-select-status-active"
                            : "navigo-appoint-non-select-status-inactive"
                        }`}
                      >
                        <span>
                          {roww?.modeStatus == true ? "Active" : "Inactive"}
                        </span>
                      </div>
                    </td>
                    <td></td>
                    <td></td>
                  </tr>
                ))
              )}

              {Boolean(
                (props?.showSeeAll ?? true) &&
                  (props?.provdersLimit
                    ? areProviderModesTruncated(providerMap?.[row.id] ?? [])
                    : false)
              ) && (
                <tr>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td
                    style={{
                      cursor: "pointer",
                      color: "#F97F0F",
                      fontWeight: 600,
                      textDecoration: "underline",
                    }}
                    onClick={(e) => {
                      e.stopPropagation();
                      if (props?.setAllProvidersOfChildService) {
                        props.setAllProvidersOfChildService({
                          assignedChildServices: (
                            props?.assignedChildServices ?? []
                          ).filter(
                            (acs) => (acs?.id ?? -2) === (row?.id ?? -1)
                          ),
                          providerMap: providerMap,
                        });
                      }
                    }}
                  >
                    See all
                  </td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                </tr>
              )}
            </React.Fragment>
          ))}
        </tbody>
      </table>

      {openBackdrop && (
        <div
          style={{
            position: "fixed",
            left: 0,
            top: 0,
            width: "100vw",
            height: "100vh",
          }}
          onClick={() => {
            setOpenFilter(-1);
            setOpenBackdrop(false);
          }}
        ></div>
      )}
    </div>
  );
};

export default ExpandableTableAssignedChildServices;
